import getAudit from './getAudit'
import exportMovimientos from './exportMovimientos'

export const getAuditPromise = getAudit
export const exportMovimientosPromise = exportMovimientos
